/**
 * 접속 기기 판별 — **웹 표면에서 토스 전용 안내를 고를 때만** 쓴다 (components/TossOnlyGate.tsx).
 *
 * 표면(web/toss) 판별은 빌드 값(lib/platform.ts)이고, 이건 그와 별개로 "웹으로 들어온 사람이
 * 휴대폰인가 PC인가"를 본다. 틀려도 피해가 작게 짠다 — 휴대폰을 PC로 보면 안내 문구만 달라지고,
 * PC를 휴대폰으로 보면 열리지 않는 토스 링크를 한 번 시도할 뿐이다.
 */

const MOBILE_UA = /Android|iPhone|iPad|iPod|Mobile|Windows Phone/i;

/**
 * 검색·미리보기 봇. 이들에게는 **화면은 똑같이 보여 주되 토스로 보내지 않는다.**
 * 봇을 앱 링크로 튕기면 페이지가 색인에서 빠지고, 화면 자체를 다르게 주면 클로킹이 된다.
 */
const CRAWLER_UA =
  /bot|crawl|spider|slurp|Yeti|Daum|facebookexternalhit|kakaotalk-scrap|Lighthouse|Google-InspectionTool/i;

export function isMobileDevice(): boolean {
  const ua = navigator.userAgent;
  if (MOBILE_UA.test(ua)) return true;
  // iPadOS 13+ 사파리는 데스크톱(Macintosh)으로 위장한다 — 터치 지점 수로 가려낸다
  return /Macintosh/.test(ua) && navigator.maxTouchPoints > 1;
}

export const isCrawler = (): boolean => CRAWLER_UA.test(navigator.userAgent);
